import apiRequest from './apiRequest';

export type Markers = Record<
  string,
  Record<
    string,
    {
      x: number;
      y: number;
      z: number;
    }
  >
>;

export default async function postCharacter({
  characterName,
  jobID,
  autoRig,
  bodyMarkerPositions,
  fileExtension,
  wsConnectionID,
  wsHttpEndpoint,
}: {
  characterName: string;
  jobID: string;
  autoRig: boolean; // true if it needs to do autorigging instead of retargeting
  bodyMarkerPositions?: Markers; // can only be included if autoRig is set to true
  fileExtension: string; // same as what is in characterUploadLink
  wsConnectionID?: string;
  wsHttpEndpoint?: string;
}) {
  return await apiRequest('mogen-orchestration', `/characters`, {
    method: 'POST',
    body: JSON.stringify({
      characterName,
      jobID,
      autoRig,
      bodyMarkerPositions,
      fileExtension,
      wsConnectionID,
      wsHttpEndpoint,
    }),
  });
}
